import LayoutMain from './LayoutMain';

export default LayoutMain;
